export default __webpack_public_path__ + "static/media/shootImg.bdf4a6be.png";